// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Dropdown Component */
.validation-message {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  margin-top: var(--ids-space-2xs);
  max-width: var(--ids-input-width-full);
}
.validation-message.has-custom-icon {
  color: var(--ids-icon-color-default);
}
.validation-message.disabled {
  color: var(--ids-input-color-text-disabled);
}
.validation-message .ids-icon {
  margin-inline-end: var(--ids-space-2xs);
}
.validation-message.alert {
  color: var(--ids-color-caution-default);
}
.validation-message.alert.disabled {
  color: var(--ids-color-yellow-30);
}
.validation-message.warning {
  color: var(--ids-color-warning-default);
}
.validation-message.warning.disabled {
  color: var(--ids-color-orange-30);
}
.validation-message.error {
  color: var(--ids-color-error-default);
}
.validation-message.error.disabled {
  color: var(--ids-color-red-30);
}
.validation-message.info {
  color: var(--ids-color-info-default);
}
.validation-message.info.disabled {
  color: var(--ids-color-blue-30);
}
.validation-message.success {
  color: var(--ids-color-success-default);
}
.validation-message.success.disabled {
  color: var(--ids-color-green-30);
}
.validation-message[hidden] {
  display: none;
}

:host ids-popup {
  max-width: var(--ids-input-width-40);
}

:host([size=xs]) ids-popup {
  max-width: var(--ids-input-width-10);
}

:host([size=sm]) ids-popup {
  max-width: calc(var(--ids-input-width-20));
}

:host([size=mm]) ids-popup {
  max-width: calc(var(--ids-input-width-30) - 2px);
}

:host([size=md]) ids-popup {
  max-width: calc(var(--ids-input-width-40) - 2px);
}

:host([size=lg]) ids-popup {
  max-width: calc(var(--ids-input-width-50) - 2px);
}

:host([size=full]) ids-popup {
  max-width: var(--ids-input-width-full);
}

:host ids-popup,
:host([size=full]) {
  width: 100%;
}

:host([position-style=fixed]) {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-dropdown/ids-dropdown-list.scss","webpack://./src/themes/mixins/ids-validation-mixin.scss","webpack://./src/themes/mixins/ids-core-mixins.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;ECQE,mCAAA;EACA,kCAAA;EDNA,aAAA;EACA,+EAAA;EACA,gCAAA;EACA,sCAAA;ADAF;ACEE;EACE,oCAAA;ADAJ;ACGE;EACE,2CAAA;ADDJ;ACIE;EACE,uCAAA;ADFJ;ACKE;EACE,uCAAA;ADHJ;ACKI;EACE,iCAAA;ADHN;ACOE;EACE,uCAAA;ADLJ;ACOI;EACE,iCAAA;ADLN;ACSE;EACE,qCAAA;ADPJ;ACSI;EACE,8BAAA;ADPN;ACWE;EACE,oCAAA;ADTJ;ACWI;EACE,+BAAA;ADTN;ACaE;EACE,uCAAA;ADXJ;ACaI;EACE,gCAAA;ADXN;ACeE;EACE,aAAA;ADbJ;;AA9CA;EACE,oCAAA;AAiDF;;AA9CA;EACE,oCAAA;AAiDF;;AA9CA;EACE,0CAAA;AAiDF;;AA9CA;EACE,gDAAA;AAiDF;;AA9CA;EACE,gDAAA;AAiDF;;AA9CA;EACE,gDAAA;AAiDF;;AA9CA;EACE,sCAAA;AAiDF;;AA9CA;;EAEE,WAAA;AAiDF;;AA9CA;EACE,cAAA;AAiDF","sourcesContent":["/* Ids Dropdown Component */\n@use '../../themes/mixins/ids-validation-mixin';\n\n// Dropdown menu width\n:host ids-popup {\n  max-width: var(--ids-input-width-40);\n}\n\n:host([size='xs']) ids-popup {\n  max-width: var(--ids-input-width-10);\n}\n\n:host([size='sm']) ids-popup {\n  max-width: calc(var(--ids-input-width-20));\n}\n\n:host([size='mm']) ids-popup {\n  max-width: calc(var(--ids-input-width-30) - 2px);\n}\n\n:host([size='md']) ids-popup {\n  max-width: calc(var(--ids-input-width-40) - 2px);\n}\n\n:host([size='lg']) ids-popup {\n  max-width: calc(var(--ids-input-width-50) - 2px);\n}\n\n:host([size='full']) ids-popup {\n  max-width: var(--ids-input-width-full);\n}\n\n:host ids-popup,\n:host([size='full']) {\n  width: 100%;\n}\n\n:host([position-style='fixed']) {\n  display: block;\n}\n","@use '../../themes/mixins/ids-core-mixins' as mixins;\n\n.validation-message {\n  @include mixins.antialiased();\n\n  display: flex;\n  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);\n  margin-top: var(--ids-space-2xs);\n  max-width: var(--ids-input-width-full);\n\n  &.has-custom-icon {\n    color: var(--ids-icon-color-default);\n  }\n\n  &.disabled {\n    color: var(--ids-input-color-text-disabled);\n  }\n\n  .ids-icon {\n    margin-inline-end: var(--ids-space-2xs);\n  }\n\n  &.alert {\n    color: var(--ids-color-caution-default);\n\n    &.disabled {\n      color: var(--ids-color-yellow-30);\n    }\n  }\n\n  &.warning {\n    color: var(--ids-color-warning-default);\n\n    &.disabled {\n      color: var(--ids-color-orange-30);\n    }\n  }\n\n  &.error {\n    color: var(--ids-color-error-default);\n\n    &.disabled {\n      color: var(--ids-color-red-30);\n    }\n  }\n\n  &.info {\n    color: var(--ids-color-info-default);\n\n    &.disabled {\n      color: var(--ids-color-blue-30);\n    }\n  }\n\n  &.success {\n    color: var(--ids-color-success-default);\n\n    &.disabled {\n      color: var(--ids-color-green-30);\n    }\n  }\n\n  &[hidden] {\n    display: none;\n  }\n}\n","// Breakpoints - this cant be tokens\n$breakpoint-xxl: 1440px;\n$breakpoint-xl: 1280px;\n$breakpoint-lg: 1024px;\n$breakpoint-md: 840px;\n$breakpoint-sm: 600px;\n$breakpoint-xs: 320px;\n\n// Sets Text Antialiasing\n@mixin antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n// vendor prefixed transitions for regular attributes (non-vendor prefixed)\n@mixin transition($transitions-list...) {\n  @each $prefix in $prefixes {\n    #{$prefix}transition: $transitions-list;\n  }\n}\n\n// make the text invisible visually but readable by screen readers\n@mixin audible() {\n  clip: rect(0, 0, 0, 0);\n  height: 0;\n  line-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
